import { Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import { RegionDialog } from '@sravni/react-region-dialog';
import { useIsMobile } from '@sravni/react-utils';
import React, { useCallback, useState } from 'react';

import { NoSSR } from 'shared/ui/NoSSR';

import { onRegionChangeHandler } from '../lib/onRegionChangeHandler';

type Props = {
  onChangeCityClick?: () => void;
};

export const UpdateUserCity: FC<Props> = (props) => {
  const { onChangeCityClick } = props;
  const isMobile = useIsMobile();
  const [isOpenedDialog, toggleRegionDialog] = useState<boolean>(false);
  const handleRegionToggle = useCallback(() => {
    onChangeCityClick?.();
    toggleRegionDialog(!isOpenedDialog);
  }, [isOpenedDialog, onChangeCityClick]);

  return (
    <>
      <Space
        align="center"
        size={8}
        style={{ cursor: 'pointer' }}
      >
        <Typography.Text
          size={14}
          onClick={handleRegionToggle}
          aria-label="Изменить город"
        >
          Изменить город
        </Typography.Text>
        <Icon icon={<ArrowRight />} />
      </Space>
      <NoSSR>
        <RegionDialog
          fullscreen={isMobile}
          visible={isOpenedDialog}
          onClose={handleRegionToggle}
          onChange={onRegionChangeHandler}
        />
      </NoSSR>
    </>
  );
};
